import React from 'react';

import { DocumentIcon, CalculatorIcon, AllocateIcon, DefineIcon, ComputeUploadIcon, PrepareIcon } from '../../assets/icons';

const WorkflowSteps = ({ activeStep, onStepChange }) => {
  const workflowSteps = [
    { name: 'Define', icon: DefineIcon, key: 'define' },
    { name: 'Upload', icon: ComputeUploadIcon, key: 'upload' },
    { name: 'Prepare', icon: PrepareIcon, key: 'prepare' },
    { name: 'Compute', icon: CalculatorIcon, key: 'compute' },
    { name: 'Allocate', icon: AllocateIcon, key: 'allocate' },
    { name: 'Returns', icon: DocumentIcon, key: 'returns' }
  ];

  const handleStepClick = (stepKey, index) => {
    if (onStepChange) {
      onStepChange(stepKey, index);
    }
  };

  return (
    <div className="flex items-center justify-center flex-1">
      {workflowSteps.map((step, index) => {
        const IconComponent = step.icon;
        const isActive = activeStep === step.key;
        return (
          <div key={step.name} className="flex items-center">
            <div
              className={`flex flex-col items-center pb-0 cursor-pointer hover:opacity-80 transition-opacity ${isActive ? 'text-orange-600' : 'text-gray-400'}`}
              onClick={() => handleStepClick(step.key, index)}
            >
              {step.name === 'Returns' ? (
                <DocumentIcon
                  className="w-7 h-7 "
                  isSelected={isActive}
                  fillColor={isActive ? 'var(--forbrand-color)' : 'var(--forbrand-secondary)'}
                />
              ) : (
                <IconComponent isSelected={isActive} sx={{ color: isActive ? 'var(--forbrand-color)' : 'var(--forbrand-secondary)' }} />
              )}
              <span className={`text-[14px]  ${isActive ? 'text-[var(--forbrand-primary)] font-bold' : 'text-[var(--forbrand-secondary)] font-normal'}`}>
                {step.name}
              </span>
              <div className={`w-20 h-[3px] mt-1 -mx-2 -mb-0 ${isActive ? 'bg-[var(--forbrand-color)]' : 'bg-transparent'}`}></div>
            </div>
            {(index < workflowSteps.length - 1) && (
              <div className="w-16 border-dashed border-[#AAAAAA] mx-4"></div>
            )}
          </div>
        );
      })}
    </div>

  );
};

export default WorkflowSteps;
